<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder"  >
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="物料编码/描述">
                                <el-input v-model="formInline.proCode" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="预测单号">
                                <el-input v-model="formInline.ycid" placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
                            border
                            max-height="500"
                            style="width: 100%">
                        <el-table-column type="selection" width="40" align="center"></el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="物料编码">
                            <template slot-scope="scope">
                                <span>{{scope.row.proCode}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proModel"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="物料描述">
                            <template slot-scope="scope">
                                <span>{{scope.row.proModel}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="factory"
                                width="80"
                                :show-overflow-tooltip="true"
                                label="工厂">
                            <template slot-scope="scope">
                                <span>{{scope.row.factory}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                width="80"
                                :show-overflow-tooltip="true"
                                label="数量">
                            <template slot-scope="scope">
                                <span>{{scope.row.proNumber}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="ycid"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="预测单号">
                            <template slot-scope="scope">
                                <span>{{scope.row.ycid}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="area"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="区域">
                            <template slot-scope="scope">
                                <dictname category="dj_foreign_area"  :v="scope.row.area"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="lgort"
                                width="80"
                                :show-overflow-tooltip="true"
                                label="库存地点">
                            <template slot-scope="scope">
                                <span>{{scope.row.lgort}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="组件">
                            <template slot-scope="scope">
                                <span>{{scope.row.materialCode}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="描述">
                            <template slot-scope="scope">
                                <span>{{scope.row.materialName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="number"
                                width="80"
                                :show-overflow-tooltip="true"
                                label="数量">
                            <template slot-scope="scope">
                                <span>{{scope.row.number}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="unit"
                                width="90"
                                :show-overflow-tooltip="true"
                                label="单位">
                            <template slot-scope="scope">
                                <span>{{scope.row.unit}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="lgort"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="库存地点">
                            <template slot-scope="scope">
                                <span>{{scope.row.lgort}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialCodeTh"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="删除物料号">
                            <template slot-scope="scope">
                                <span>{{scope.row.materialCodeTh}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="materialNameTh"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="删除物料">
                            <template slot-scope="scope">
                                <span>{{scope.row.materialNameTh}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="numberTh"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="删除物料数量">
                            <template slot-scope="scope">
                                <span>{{scope.row.numberTh}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="unitTh"
                                width="120"
                                :show-overflow-tooltip="true"
                                label="删除物料单位">
                            <template slot-scope="scope">
                                <span>{{scope.row.unitTh}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="exportExcel">批量导出
                            </el-button>
                        </div>
                        <div class="h-pagination2 h-pageCenter">
                            <pagination :page="formInline" @query="query" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
                formInline: {
                    proCode:null,
                    ycid:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
            }
        },
        mounted() {

        },
        created() {
            this.query();
        },
        methods: {
            handleFilter(){
                this.query();
            },
            query(){
                ss.waixiao.reformPage(this.formInline).then(rd =>{
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            resetData(){
                this.formInline.proCode = '';
                this.formInline.ycid = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.query();
            },
            //明细导出
            exportExcel() {
                var data = {
                    proCode: null,
                    factory: null,
                    ycid: null,
                }

                data = _.clone(this.formInline);

                updownfile.down("/api/swyl/v1/demo/viewReformDetail/downloadExcel",data,"post");
            },
        },
    }

</script>